var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 7,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4039 2.45742H10.8029V1.39497C10.8029 0.624493 10.1622 0 9.37551 0H6.49635C5.70965 0 5.06894 0.624493 5.06894 1.39497V2.45742H1.46796C0.656934 2.45742 0 3.09813 0 3.89294V5.45012C0 5.78264 0.27575 6.04217 0.608272 6.04217H15.2636C15.5961 6.04217 15.8719 5.77453 15.8719 5.45012V3.89294C15.8719 3.09813 15.2149 2.45742 14.4039 2.45742ZM9.56204 2.45742H6.30981V1.39497C6.30981 1.29765 6.39092 1.21655 6.48824 1.21655H9.37551C9.47283 1.21655 9.56204 1.29765 9.56204 1.39497V2.45742Z",
    fill: "#727272"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 1,
    y: 7,
    width: 14,
    height: 13,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0625 0.128944C0.378802 4.12732 0.686993 8.1257 1.00329 12.1241C1.00329 12.6107 1.36826 13.0081 1.81432 13.0081H6.34798H7.64563H12.1793C12.6254 13.0081 12.9903 12.6107 12.9903 12.1241C13.3066 8.1257 13.6148 4.12732 13.9311 0.128944C11.6197 0.137055 9.30824 0.145165 7.00492 0.153275C4.68537 0.145165 2.37394 0.137055 0.0625 0.128944ZM3.87434 11.2725C3.85812 11.2725 3.8419 11.2725 3.82568 11.2725C3.50938 11.2725 3.24174 11.0292 3.21741 10.7129L2.59291 2.52148C2.56858 2.18896 2.82 1.89699 3.15252 1.87266C3.48505 1.85644 3.77702 2.09975 3.80135 2.43227L4.42584 10.6237C4.45828 10.9481 4.20686 11.2401 3.87434 11.2725ZM10.322 2.42416C10.3464 2.09164 10.6546 1.84833 10.9709 1.86455C11.3034 1.88888 11.5548 2.18085 11.5305 2.51337L10.906 10.7048C10.8816 11.0211 10.614 11.2644 10.2977 11.2644C10.2815 11.2644 10.2653 11.2644 10.249 11.2644C9.91651 11.2401 9.6651 10.9481 9.68943 10.6156L10.322 2.42416ZM7.60508 2.4566V10.6723C7.60508 11.0049 7.32933 11.2806 6.99681 11.2806C6.66428 11.2806 6.38853 11.0049 6.38853 10.6723V2.4566C6.38853 2.12408 6.66428 1.84833 6.99681 1.84833C7.32933 1.84833 7.60508 2.12408 7.60508 2.4566Z",
    fill: "#727272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.2b87dca0f1a120a34ac60542fe4b7c9a.svg";
export { ForwardRef as ReactComponent };